jQuery(document).ready(function () {
    var $product = $('form[action="/cart/add"]');
    var productData = JSON.parse(document.getElementById('product-data').innerHTML);
    var $productPrice = $('.product-overview__price');

    $('.parameters__item .parameters__form-control').on('change', function (e) {
        if (e.originalEvent === undefined) {
            // return;
        }

        var option1 = $product.find('.parameters__list[data-index=option1]').find('.parameters__form-control:checked').val();
        var option2 = $product.find('.parameters__list[data-index=option2]').find('.parameters__form-control:checked').val();

        // choose the first options if none is checked
        if (!option1) {
            var $option1 = $product.find('.parameters__list[data-index=option1]').find('.parameters__form-control').first();
            option1 = $option1.val();

            $option1.next().trigger('click');
        }

        if (!option2) {
            var $option2 = $product.find('.parameters__list[data-index=option2]').find('.parameters__form-control').first();
            option2 = $option2.val();

            $option2.next().trigger('click');
        }

        var variant = null;
        productData.variants.forEach(function (v) {
            if (v.option1 == option1 && v.option2 == option2) {
                variant = v;
                return false;
            }
        });

        if (variant) {
            $productPrice.html(Shopify.formatMoney(variant.price));
            $product.find('[name=id]').val(variant.id);

            if (variant.available) {
                $product.find('button[name=add]').removeClass('disabled').removeAttr('disabled');
            } else {
                $product.find('button[name=add]').addClass('disabled').attr('disabled', 'disabled');
            }

            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
            window.history.replaceState({
                path: newurl
            }, '', newurl);

            if ( typeof snaptr === 'function' ) {
                // trigger VIEW_CONTENT event
                snaptr('track', 'VIEW_CONTENT', {
                    'currency': Shopify.currency.active,
                    'price': variant.price / 100,
                    'item_category': productData.id,
                    'item_ids': variant.id,
                    'description': variant.name
                });
            }
        }

    });

    // Handle personalization
    $('.personalization-modal .btn-save-personalization').on('click', function (evt) {
        evt.preventDefault();
        var $modal = $(this).closest('.personalization-modal');
        var canPass = true;

        $modal.find('.customization-container').each(function (i, item) {
            var $item = $(item);
            var $checkbox = $item.find('input[type=checkbox]').first();

            if ($checkbox.is(':checked')) {
                if (!$item.find('.customization-value').val().length) {
                    $item.find('.error-message').show();
                    canPass = false;
                } else {
                    $item.find('.error-message').hide();
                }
            } else {
                $item.find('.customization-value').val('').trigger('change');
                $item.find('.error-message').hide();
            }
        });

        var $personalizationToggle = $('.personalization-modal-toggle span');
        var personalizationToggleText = $personalizationToggle.data('label-add');

        if (canPass) {
            personalizationToggleText = $personalizationToggle.data('label-update');
            $modal.find('.modal-close').trigger('click');

            // Put the SAVE button in disabled state
            $('.personalization-modal .btn-save-personalization').attr('disabled', 'disabled').addClass('disabled pointer-events-none');
        }

        if ($modal.find('input[type=checkbox]:checked').length) {
            personalizationToggleText = $personalizationToggle.data('label-update');
        } else {
            personalizationToggleText = $personalizationToggle.data('label-add');
        }

        $personalizationToggle.text(personalizationToggleText);
    });

    $('.personalization-modal .modal-close').on('click', function (evt) {
        var $this = $(this);

        if (evt.originalEvent == 'undefined') {
            return false;
        }

        var $modal = $this.closest('.personalization-modal');

        $modal.find('.customization-container').each(function (i, item) {
            var $item = $(item);
            var $checkbox = $item.find('input[type=checkbox]').first();
            var $text = $item.find('.customization-value').first();

            // uncheck option if text is empty
            if (!$text.val().length) {
                $checkbox.prop('checked', false).trigger('change');
                $item.find('.error-message').hide();

                return true;
            }

            // clear text if option is checked
            if (!$checkbox.is(':checked')) {
                $item.find('.customization-value').val('').trigger('change');
                $item.find('.error-message').hide();
            }
        });

        var $personalizationToggle = $('.personalization-modal-toggle span');
        var personalizationToggleText = $personalizationToggle.data('label-add');

        if ($modal.find('input[type=checkbox]:checked').length) {
            personalizationToggleText = $personalizationToggle.data('label-update');
        }

        $personalizationToggle.text(personalizationToggleText);

        // Put the SAVE button in disabled state
        $('.personalization-modal .btn-save-personalization').attr('disabled', 'disabled').addClass('disabled pointer-events-none');
    });

    // Hide message on checkbox uncheck
    $(document).on('change keyup', '.personalization-modal input[type=checkbox], .personalization-modal .customization-value', function () {
        var $this = $(this);
        var $container = $this.closest('.customization-container');
        var $checkbox = $container.find('input[type=checkbox]').first();
        var $text = $container.find('.customization-value').first();
        var $saveButton = $container.closest('.personalization-modal').find('.btn-save-personalization');

        if ($this.is('input[type=checkbox]')) {
            if (this.checked) {
                $text.removeAttr('readonly').focus();
            } else {
                $text.attr('readonly', 'readonly');
            }

            $container.find('.error-message').hide();
        }

        // if (this.checked) {
        //     $container.find('.error-message').show();
        //     $saveButton.removeAttr('disabled').removeClass('disabled pointer-events-none');
        //     } else {
        //     $container.find('.error-message').hide();
        //     $saveButton.attr('disabled', 'disabled').addClass('disabled pointer-events-none');
        // }

        // if ($this.is('.customization-value')) {
        //     // Modify option when text is modified
        //     if ($this.val().length) {
        //         $checkbox.prop('checked', true).trigger('change');

        //     } else {
        //         $checkbox.prop('checked', false).trigger('change');
        //     }
        // }

        $saveButton.removeAttr('disabled').removeClass('disabled pointer-events-none');
    });

    // Toggle value field against checkbox
    $('.product-customizations input[type=checkbox]').on('change', function () {
        $(this).closest('.customization-container').find('.customization-value-wrapper').slideToggle(this.checked);
    });

    // Function to validate size and color selections
    function validateSizeAndColor($form) {
        var errors = false;

        // Check if size is selected
        var sizeSelected = $form.find('.parameters__list[data-index=option1] .parameters__form-control:checked').length > 0;
        if (!sizeSelected) {
            $form.find('.parameters--size .parameters__headline--error').css('display', 'block');
            errors = true;
        } else {
            $form.find('.parameters--size .parameters__headline--error').css('display', 'none');
        }

        // Check if color is selected
        var colorSelected = $form.find('.parameters__list[data-index=option2] .parameters__form-control:checked').length > 0;
        if (!colorSelected) {
            $form.find('.parameters--color .parameters__headline--error').css('display', 'block');
            errors = true;
        } else {
            $form.find('.parameters--color .parameters__headline--error').css('display', 'none');
        }

        return { isValid: !errors, errorMessage: errors ? 'Please select size and color' : '' };
    }

    // Function to validate all personalization inputs
    function validatePersonalization($form, showPopup = true) {
        var boldOptions = [];
        var validKeys = ['left_sleeve', 'left', 'back']; // Valid keys (case-insensitive)
        var errors = [];
        var checkedCount = 0; // Track number of checked personalization options

        // Check for empty values, multiple selections, keys, values, and collect boldOptions
        $form.find('.product-customizations .customization-container').each(function (i, option) {
            var $option = $(option);
            if ($option.find('input[type=checkbox]').is(':checked')) {
                checkedCount++; // Increment for each checked option

                // Check for multiple .customization-name inputs (keys) in a single container
                var keyInputs = $option.find('.customization-name');
                if (keyInputs.length > 1) {
                    errors.push('Multiple personalization keys detected in a single option. Please use only one key.');
                    if (showPopup) {
                        var productInputPopup = document.getElementById('productInputPopup');
                        if (productInputPopup) {
                            productInputPopup.classList.remove('product-popup-hidden');
                            productInputPopup.classList.add('product-popup-show');
                            productInputPopup.querySelector('.product-popup-body').innerHTML = errors[0];
                        }
                    }
                    return; // Skip further validation for this container
                }

                // Check for multiple .customization-value inputs in a single container
                var valueInputs = $option.find('.customization-value');
                if (valueInputs.length > 1) {
                    errors.push('Multiple personalization values detected in a single option. Please select only one value.');
                    if (showPopup) {
                        var productInputPopup = document.getElementById('productInputPopup');
                        if (productInputPopup) {
                            productInputPopup.classList.remove('product-popup-hidden');
                            productInputPopup.classList.add('product-popup-show');
                            productInputPopup.querySelector('.product-popup-body').innerHTML = errors[0];
                        } 
                    }
                    return; // Skip further validation for this container
                }

                var optionValue = valueInputs.val();
                var keyInput = keyInputs.first();
                var key = keyInput.length ? keyInput.val().toLowerCase() : `option_${i}`;
                var personalizationAttr = valueInputs.attr('data-personalization')?.toLowerCase();
                var isLegitimate = valueInputs.attr('data-legitimate') === 'true';

                // Validate key consistency
                if (personalizationAttr && personalizationAttr !== key) {
                    errors.push('Personalization key mismatch. The selected option does not match the input value.');
                    if (showPopup) {
                        var productInputPopup = document.getElementById('productInputPopup');
                        if (productInputPopup) {
                            productInputPopup.classList.remove('product-popup-hidden');
                            productInputPopup.classList.add('product-popup-show');
                            productInputPopup.querySelector('.product-popup-body').innerHTML = errors[0];
                        }
                    }
                    return; // Skip further validation for this container
                }

                if (!optionValue.length) {
                    $option.find('.error-message').show();
                    errors.push('Personalization value cannot be empty.');
                } else if (!isLegitimate) {
                    $option.find('.error-message').show();
                    errors.push('Personalization value was not entered through the form. Please enter a value manually.');
                    valueInputs.val(''); // Clear non-legitimate value
                } else {
                    $option.find('.error-message').hide();
                    // Check for reserved words
                    if (['LEFTSLEEVE', 'RIGHTSLEEV', 'LEFT', 'RIGHT'].includes(optionValue.toUpperCase())) {
                        var errorMessage = `<p>It looks like you added "<span class="error-value">${optionValue}</span>" as personalization on your item.</p><p>Please confirm that what you have entered is exactly what you would like printed on your item. You cannot change this after the order is placed.</p>`;
                        if (showPopup) {
                            var productPopup = document.getElementById('productPopup');
                            if (productPopup) {
                                productPopup.classList.remove('product-popup-hidden');
                                productPopup.classList.add('product-popup-show');
                                productPopup.querySelector('.product-popup-body').innerHTML = errorMessage;
                            }
                        }
                        errors.push('Reserved word detected: ' + optionValue);
                    } else {
                        // Collect for BOLD_GRADWEAR_OPTIONS validation
                        boldOptions.push({ key: key, value: optionValue });
                    }
                }
            }
        });

        // Check for multiple checked personalization options
        if (checkedCount > 1) {
            errors.push('Multiple customization options selected. Please select only one option.');
        }

        // Validate BOLD_GRADWEAR_OPTIONS
        if (boldOptions.length > 1) {
            errors.push('Multiple customization options selected. Please select only one option.');
        } else if (boldOptions.length === 1) {
            var option = boldOptions[0];
            if (!validKeys.includes(option.key.toLowerCase())) {
                errors.push('Invalid customization option selected. Please choose Left Sleeve, Left, or Back.');
            } else if (option.value.includes(' ')) {
                errors.push('Customization value contains spaces. Please use a single word without spaces.');
            } else if (option.value.length > 10) {
                errors.push('Customization value is too long. Please use 10 characters or less.');
            }
        }

        // Show the first error in the popup if any
        if (errors.length > 0 && showPopup && !errors[0].includes('Reserved word detected')) {
            var productInputPopup = document.getElementById('productInputPopup');
            if (productInputPopup) {
                productInputPopup.classList.remove('product-popup-hidden');
                productInputPopup.classList.add('product-popup-show');
                productInputPopup.querySelector('.product-popup-body').innerHTML = errors[0];
            }
        }

        return { isValid: errors.length === 0, errorMessage: errors.length > 0 ? errors[0] : '' };
    }

    // Combined validation function
    function validateForm($form, showPopup = true) {
        var sizeColorValidation = validateSizeAndColor($form);
        var personalizationValidation = validatePersonalization($form, showPopup);

        var isValid = sizeColorValidation.isValid && personalizationValidation.isValid;
        var errorMessage = '';

        if (!sizeColorValidation.isValid) {
            errorMessage = sizeColorValidation.errorMessage;
        } else if (!personalizationValidation.isValid) {
            errorMessage = personalizationValidation.errorMessage;
        }

        // Only show popup for personalization errors, let inline errors handle size/color
        if (!personalizationValidation.isValid && showPopup) {
            var productInputPopup = document.getElementById('productInputPopup');
            if (productInputPopup) {
                productInputPopup.classList.remove('product-popup-hidden');
                productInputPopup.classList.add('product-popup-show');
                productInputPopup.querySelector('.product-popup-body').innerHTML = personalizationValidation.errorMessage;
            }
        }

        return { isValid: isValid, errorMessage: errorMessage };
    }

    // Handle form submission
    $('form[action="/cart/add"]').on('submit', function (evt) {
        evt.preventDefault(); // Prevent default submission initially
        evt.stopImmediatePropagation(); // Stop other handlers

        var $form = $(this);
        var validation = validateForm($form);

        if (validation.isValid) {
            $form.off('submit'); // Remove this handler to avoid recursion
            $form.submit(); // Trigger native submission
        }
    });

    // Handle Add to Cart button click
    $('[name=add]').on('click', function (evt) {
        evt.preventDefault(); // Prevent default action
        evt.stopImmediatePropagation(); // Stop other handlers

        var $form = $('form[action="/cart/add"]');
        var validation = validateForm($form);

        if (validation.isValid) {
            $form.off('submit'); // Remove submit handler to avoid recursion
            $form.submit(); // Trigger form submission
        }
    });

    // Mark personalization inputs as legitimate when modified via UI
    $('form[action="/cart/add"]').on('input', '.customization-value', function () {
        $(this).attr('data-legitimate', 'true');
    });

    // Initialize customization-value inputs with data-legitimate=false
    $('form[action="/cart/add"] .customization-value').each(function () {
        $(this).attr('data-legitimate', 'false');
    });

    document.getElementById('yesButton').addEventListener('click', function() {
        var productPopup = document.getElementById('productPopup');
        $('form[action="/cart/add"]').trigger('submit');
        productPopup.classList.remove('product-popup-show');
        productPopup.classList.add('product-popup-hidden');
    });
    document.querySelector('.popup-cancel-button').addEventListener('click', function() {
        var productPopup = document.getElementById('productPopup');
        productPopup.classList.remove('product-popup-show');
        productPopup.classList.add('product-popup-hidden');
    });
    document.querySelector('#noButton').addEventListener('click', function() {
        var productPopup = document.getElementById('productPopup');
        productPopup.classList.remove('product-popup-show');
        productPopup.classList.add('product-popup-hidden');
    });
    document.querySelector('.popup-input-cancel-button').addEventListener('click', function() {
        var productInputPopup = document.getElementById('productInputPopup');
        productInputPopup.classList.remove('product-popup-show');
        productInputPopup.classList.add('product-popup-hidden');
    });
});

var ProductCustomization = function (id, product, backProduct) {
    this.id = id;
    this.$container = $('.customization-container[data-product-id="' + id + '"]');
    this.$customizationWrappers = this.$container.find('.customization-wrapper');
    this.$variantNames = this.$container.find('.customization-variant-names');
    this.$variantPrices = this.$container.find('.customization-variant-prices');
    this.$variantIds = this.$container.find('.customization-variant-ids');
    this.$productIds = this.$container.find('.customization-product-ids');
    this.$variantQuantities = this.$container.find('.customization-variant-quantities');
    this.product = product;
    this.backProduct = backProduct;

    this.bindListeners();
}

ProductCustomization.prototype.bindListeners = function () {
    this.$customizationWrappers.find('input[type="checkbox"]').on('change', function (event) {
        var $element = $(event.target);

        this.updateCustomization($element);
        this.updateCharges();
        if (!$element.is(':checked')) {
            $element.parents('.customization-wrapper').find('.customization-value-copy').remove();
        } else {
            var builderID = document.createElement('input');
            builderID.type = 'hidden';
            builderID.name = "properties[_boldBuilderId]";
            builderID.value = new Date();

            $('#product_form_' + this.id).append(builderID);
        }
    }.bind(this));

    this.$customizationWrappers.find('.customization-value').on('change', function (event) {
        var $element = $(event.target);
        var customizationName = $element.attr('data-personalization');
        $element.parent().find('.customization-value-copy').remove();

        if ($element.val() != '') {
            var productInputPopup = document.getElementById('productInputPopup');
            
            if(!$element.val().checkInput()) {
              productInputPopup.classList.remove('product-popup-hidden');
              productInputPopup.classList.add('product-popup-show');
            } else {
              $element.val($element.val().toUpperCase().cleanup());
              $element.after('<input type="hidden" class="customization-value-copy" name="properties[' + customizationName + ']" value="' + $element.val().toUpperCase() + '"/>');              
            }
        }

        this.updateCharges();
    }.bind(this));

    this.$customizationWrappers.find('.customization-value').on('keydown', function (event) {
        if ((event.keyCode < 65 || event.keyCode > 90) &&
            event.keyCode !== 8 // backspace
            &&
            event.keyCode !== 46 // del
            &&
            event.keyCode !== 35 // end
            &&
            event.keyCode !== 36 // home
            &&
            event.keyCode !== 37 // arrow left
            &&
            event.keyCode !== 38 // arrow up
            &&
            event.keyCode !== 39 // arrow right
            &&
            event.keyCode !== 40 // arrow down
        ) {
            event.preventDefault();
            return false;
        }
    }.bind(this));

    String.prototype.cleanup = function () {
        return this.toUpperCase().replace(/[^a-zA-ZàÀéÉîÎœŒüÜÿŸçÇÈèÙùÂâÊêÔôÛûËëÏïÆæ]/g, "");
    }

    String.prototype.checkInput = function () {
       return /^[a-zA-ZàÀéÉîÎœŒüÜÿŸçÇÈèÙùÂâÊêÔôÛûËëÏïÆæ\s]+$/.test(this);
    }
}

ProductCustomization.prototype.updateCustomization = function ($element) {
    var $container = $element.parents('.customization-wrapper');
    var $customizationName = $container.find('.customization-name');
    var $customizationPrice = $container.find('.customization-price');
    var $customizationValue = $container.find('.customization-value');

    var customizationName = $customizationName.attr('data-value');
    var nameDataName = $customizationName.attr('data-name');
    var priceDataName = $customizationPrice.attr('data-name');
    var valueDataName = $customizationValue.attr('data-name');

    if ($element.is(':checked')) {
        $container.addClass('open');
        $customizationPrice.val($customizationPrice.attr('data-price'));
        $customizationName.val(customizationName);
        $customizationName.attr('name', nameDataName);
        $customizationPrice.attr('name', priceDataName);
        $customizationValue.attr('name', valueDataName);
    } else {
        $container.removeClass('open');
        $customizationValue.val('');
        $customizationPrice.val('');
        $customizationName.val('');
        $customizationName.attr('name', '');
        $customizationPrice.attr('name', '');
        $customizationValue.attr('name', '');
    }
}

ProductCustomization.prototype.updateCharges = function () {
    var $checkedOptions = this.$container.find('input[type="checkbox"]:checked');
    var quantity = $checkedOptions.length;
    var variant = this.product.variants[0];
    var customizations = {};

    $checkedOptions.each(function (index, el) {
        var value = $(el).parents('.customization-wrapper').find('.customization-value').val();
        var price = $(el).attr('data-price');
        var variant = $(el).attr('data-variant');
        var product = $(el).attr('data-product');

        if (value != '') {
            if (!customizations[variant]) {
                customizations[variant] = {
                    variant: variant,
                    id: product,
                    qty: 0,
                    price: price
                };
            }

            customizations[variant].qty++;
        }
    });

    var variantIds = Object.keys(customizations).map(function (key, index) {
        return customizations[key].variant;
    });

    var productIds = Object.keys(customizations).map(function (key, index) {
        return customizations[key].id;
    });

    var variantQtys = Object.keys(customizations).map(function (key, index) {
        return customizations[key].qty;
    });

    var variantPrices = Object.keys(customizations).map(function (key, index) {
        return customizations[key].price;
    });

    if (variantIds.length > 0) {
        this.$variantNames.val('Personalization').attr('name', 'properties[_boldVariantNames]');
        this.$variantPrices.val(variantPrices.join(',')).attr('name', 'properties[_boldVariantPrices]');
        this.$variantIds.val(variantIds.join(',')).attr('name', 'properties[_boldVariantIds]');
        this.$productIds.val(productIds.join(',')).attr('name', 'properties[_boldProductIds]');
        this.$variantQuantities.val(variantQtys.join(',')).attr('name', 'properties[_boldVariantQtys]');
    } else {
        this.$variantNames.val('').attr('name', '');
        this.$variantPrices.val('').attr('name', '');
        this.$variantIds.val('').attr('name', '');
        this.$productIds.val('').attr('name', '');
        this.$variantQuantities.val('').attr('name', '');
    }
}
window.onload = function() {
    // Get the element with the class name '.product-customizations'
    const productCustomizations = document.querySelector('.product-customizations');
    // Select all checkbox inputs that are children of '.product-customizations'
    let allCheckBoxes = productCustomizations.querySelectorAll('input[type="checkbox"]');
    allCheckBoxes.forEach((checkBox) => {
      checkBox.checked = false;
    })
};